import {FC, useMemo} from 'react';
import {Box, Chip, Typography} from '@mui/material';
import {countMagicCardStatuses} from '../../utils/magicCardSummary';
import type {WordInfo} from '../../types/wordbook';

interface Props {
    words: WordInfo[];
}

export const MagicCardSummaryBadges: FC<Props> = ({words}) => {
    const counts = useMemo(() => countMagicCardStatuses(words), [words]);

    if (counts.total === 0) return null;

    return (
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={1}>
            <Typography variant="body2" color="text.secondary" sx={{fontWeight: 500}}>
                매직카드:
            </Typography>
            <Chip label={`준비됨 ${counts.ready}`} size="small" color="success"/>
            <Chip label={`생성 중 ${counts.generating}`} size="small" color="info"/>
            <Chip label={`대기 ${counts.queued}`} size="small" color="default"/>
            <Chip label={`실패 ${counts.failed}`} size="small" color="error"/>
            <Chip label={`캐시 있음 ${counts.cacheOnly}`} size="small" color="secondary" variant="outlined"/>
            <Chip label={`미생성 ${counts.none}`} size="small" color="default" variant="outlined"/>
            <Typography variant="caption" color="text.secondary">
                / 총 {counts.total}
            </Typography>
        </Box>
    );
};
